'use client';

import React, { FC } from 'react';

import DatePicker, { DatePickerProps } from 'react-datepicker';

import './CalendarDatePicker.scss';

interface CalendarDatePickerProps extends Omit<DatePickerProps, 'onChange'> {
  onChange: (date: Date) => void;
  rangeStart?: Date;
  rangeEnd?: Date;
}

const CalendarDatePicker: FC<CalendarDatePickerProps> = ({
  onChange,
  selected,
  rangeStart,
  rangeEnd,
  highlightDates,
}) => (
  <DatePicker
    inline
    previousMonthButtonLabel=""
    nextMonthButtonLabel=""
    calendarStartDay={1}
    onChange={(date) => date && onChange(date)}
    selected={selected}
    minDate={rangeStart}
    startDate={rangeStart}
    maxDate={rangeEnd}
    endDate={rangeEnd}
    highlightDates={highlightDates}
  />
);

export default CalendarDatePicker;
